/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MultipleChoiceAnswer
 */
export interface MultipleChoiceAnswer {
    /**
     * 
     * @type {number}
     * @memberof MultipleChoiceAnswer
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof MultipleChoiceAnswer
     */
    text: string;
    /**
     * 
     * @type {boolean}
     * @memberof MultipleChoiceAnswer
     */
    correct: boolean;
    /**
     * 
     * @type {number}
     * @memberof MultipleChoiceAnswer
     */
    question: number;
}

/**
 * Check if a given object implements the MultipleChoiceAnswer interface.
 */
export function instanceOfMultipleChoiceAnswer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "correct" in value;
    isInstance = isInstance && "question" in value;

    return isInstance;
}

export function MultipleChoiceAnswerFromJSON(json: any): MultipleChoiceAnswer {
    return MultipleChoiceAnswerFromJSONTyped(json, false);
}

export function MultipleChoiceAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultipleChoiceAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'text': json['text'],
        'correct': json['correct'],
        'question': json['question'],
    };
}

export function MultipleChoiceAnswerToJSON(value?: MultipleChoiceAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'text': value.text,
        'correct': value.correct,
        'question': value.question,
    };
}

